import Col from 'blocks/Col';

import * as S from './alertBox.styles';
import { AlertBoxProps } from './alertbox.interface';

const AlertBox = ({ type, text, children }: AlertBoxProps) => (
  <S.Wrapper>
    <Col align="center">
      <img src={`/passenger/images/${type}.svg`} alt="icon" />

      <S.AlertTitle $type={type}>{text}</S.AlertTitle>
      {children && <S.Alertdesc>{children}</S.Alertdesc>}
    </Col>
  </S.Wrapper>
);

export default AlertBox;
